import { Link } from 'react-router-dom';
import './styles/NotFound.scss';

export const NotFound = () => {
  return (
    <div className="not-found">
      <div className="not-found__code">404</div>
      <h1 className="not-found__title">Page not found</h1>
      <p className="not-found__sub">The page you&apos;re looking for doesn&apos;t exist.</p>
      <Link to="/devices" className="not-found__link">
        Go to Devices
      </Link>
    </div>
  );
};
